import { Navbar } from "../molecule/";

const RealEstatePage = (props) => {
  return (
    <>
      <Navbar pathname={props.location.pathname} />
      <div style={{ height: 56 + 16 }} />

      <div className={"container"}>
        <br />
        <div>Hello, World!</div>
      </div>
    </>
  );
};

export { RealEstatePage };
